import { IProduct } from 'shared/map-search/types/analytics';

import { IApplicationState } from '../../types/redux';

export function selectOfferChatProduct(state: IApplicationState): IProduct | undefined {
  return state.chatModal.product;
}
